import { Sidebar } from '@/shared/components/ui/sidebar'
import { getStoryFromFirestore, syncScriptWithFirebaseStory } from '@/service/firestore'
import React from 'react'
import { useAuth } from '@/features/auth'
import { NavItemsSimple } from '@/components/custom/nav-Items-simple'
import { setJsonScriptEditor } from '@/features/screenplay/components/editor/utils/JsonUtils'
import { useWorkspace } from '@/features/workspace'
import { WorkspaceSidebarScaffold } from '@/features/workspace'
import { stData } from './editor/stories/stData'
import { useStoryStore } from '@/features/shared/stores/story.store'

const StEditorSidebar = ({ ...props }: React.ComponentProps<typeof Sidebar>) => {
    const { project } = useWorkspace()
    const { editor } = useStoryStore()
    const { user } = useAuth()

    const subMenuData = [
        {
            name: 'Load Json',
            emoji: '📥',
            onClick: async () => {
                console.log('syncing')

                const data = stData
                setJsonScriptEditor(editor, data ?? [])
            },
        },
        {
            name: 'Sync Script Down',
            emoji: '🔄',
            onClick: async () => {
                console.log('syncing')

                const data = await getStoryFromFirestore(user!.uid, project!.id)
                console.log('>>', data)
                setJsonScriptEditor(editor, data?.content ?? [])
            },
        },
        {
            name: 'Upload to Database',
            emoji: '📤',
            onClick: async () => {
                syncScriptWithFirebaseStory(user!.uid, project!.id)
            },
        },
    ]
    return (
        <WorkspaceSidebarScaffold>
            {subMenuData.length !== 0 && (
                <NavItemsSimple navItems={subMenuData} header={{ title: 'Options' }} />
            )}
        </WorkspaceSidebarScaffold>
    )
}

export default StEditorSidebar
